import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import { toggleCategory, toggleSubCategory } from './redux/action';
import SideMenuComponent from './side-menu-component';

const mapStateToProps = (state: ApplicationState, ownProps: any) => ({
  sideMenu: state.sideMenu,
  t: state.i18n.t
});

export default connect(mapStateToProps, { toggleCategory, toggleSubCategory })(SideMenuComponent);
